import { render, staticRenderFns } from "./PlayerDebtForgiven.vue?vue&type=template&id=275aff48&scoped=true&"
import script from "./PlayerDebtForgiven.vue?vue&type=script&lang=js&"
export * from "./PlayerDebtForgiven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275aff48",
  null
  
)

export default component.exports